import { render, staticRenderFns } from "./TeamEditor.vue?vue&type=template&id=6747f9bb&scoped=true&"
import script from "./TeamEditor.vue?vue&type=script&lang=ts&"
export * from "./TeamEditor.vue?vue&type=script&lang=ts&"
import style0 from "./TeamEditor.vue?vue&type=style&index=0&id=6747f9bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6747f9bb",
  null
  
)

export default component.exports